import React from 'react';
import { ArrowRightLeft } from 'lucide-react';
import { IBookingExternalAPILog } from 'libs/data-access/types';
import { PayloadCard } from './PayloadCard';

interface ILogItemProps {
    log: IBookingExternalAPILog;
    isDownloading: boolean;
    onDownload: (mediaId: number, fileName: string) => void;
}

export const LogItem: React.FC<ILogItemProps> = ({
    log,
    isDownloading,
    onDownload
}) => {
    return (
        <div className="p-4 bg-white border border-gray-200 rounded-lg hover:border-gray-300 transition-colors">
            {/* Header */}
            <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-2">
                    <div className="p-2 bg-blue-50 rounded-lg">
                        <ArrowRightLeft size={16} className="text-blue-600" />
                    </div>
                    <div>
                        <span className="text-xs font-semibold text-blue-600 uppercase tracking-wide">
                            {log.apiType}
                        </span>
                        <div className="text-xs text-gray-500 mt-0.5">
                            Log ID: {log.id}
                        </div>
                    </div>
                </div>
            </div>

            {/* Payload Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {log.requestPayloadMediaId && (
                    <PayloadCard
                        type="request"
                        mediaId={log.requestPayloadMediaId}
                        fileName={`${log.apiName}_request_${log.traceId}_${log.id}.${log.apiType}`}
                        isDownloading={isDownloading}
                        onDownload={onDownload}
                    />
                )}

                {log.responsePayloadMediaId && (
                    <PayloadCard
                        type="response"
                        mediaId={log.responsePayloadMediaId}
                        fileName={`${log.apiName}_response_${log.traceId}_${log.id}.${log.apiType}`}
                        isDownloading={isDownloading}
                        onDownload={onDownload}
                    />
                )}
            </div>

            {/* Footer */}
            <div className="flex items-center gap-3 mt-4 pt-3 border-t border-gray-100">
                <span className="text-xs text-gray-500 font-mono">
                    Trace: {log.traceId}
                </span>
            </div>
        </div>
    );
};
